import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { YouTubePlayerModule as AngularYouTubePlayerModule } from '@angular/youtube-player';
import { PictureInPictureModule } from '@epicuro-next/ataraxia/picture-in-picture';

import { YoutubePlayerComponent } from './components/youtube-player/youtube-player.component';
import { YoutubeApiService } from './services/youtube-api.service';

@NgModule({
  imports: [CommonModule, AngularYouTubePlayerModule, PictureInPictureModule],
  declarations: [YoutubePlayerComponent],
  exports: [YoutubePlayerComponent],
  providers: [YoutubeApiService],
})
export class YoutubePlayerModule {
  constructor(public youtubeService: YoutubeApiService) {}
}
